import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { WithdrawalMethodId } from '../../entities';
import { AdvcashFormComponent } from './advcash-form/advcash-form.component';
import { BankTransferInrFormComponent } from './bank-transfer-inr/bank-transfer-inr-form.component';
import { CardPersonalFormComponent } from './card-personal-form/card-personal-form.component';
import { CodeOfficeFormComponent } from './code-office-form/code-office-form.component';
import { CryptoFormComponent } from './crypto-form/crypto-form.component';
import { PaypalFormComponent } from './paypal-form/paypal-form.component';

@Component({
  selector: 'iw-apm-form',
  imports: [
    PaypalFormComponent,
    CardPersonalFormComponent,
    AdvcashFormComponent,
    BankTransferInrFormComponent,
    CodeOfficeFormComponent,
    CryptoFormComponent,
  ],
  templateUrl: './apm-form.component.html',
  styleUrl: './apm-form.component.scss',
})
export class ApmFormComponent {
  method = input<WithdrawalMethodId>();
  form = input<FormGroup>();

  readonly withdrawalMethodIdEnum = WithdrawalMethodId;
}
